import SegmentContent from './SegmentContent';
export default SegmentContent;
